const translations = {
    pt: {
        assignedTasks: 'Tarefas Atribuídas',
        back: 'Voltar',
        failedToFetch: 'Falha ao buscar tarefas: ',
        failedToUpdate: 'Falha ao atualizar tarefa: ',
        taskMarkedAs: 'Tarefa marcada como ',
        editContent: 'Editar Conteúdo',
        markAsFinished: 'Marcar como Finalizada',
        currentOpenTask: 'Tarefa Aberta Atual',
        waitingForReview: 'Aguardando Revisão',
        closedTasks: 'Tarefas Fechadas',
        createdOn: 'Criada em: ',
        instructions: 'Instruções: ',
        comments: 'Comentários: ',
        none: 'Nenhuma',
        taskNumber: 'Tarefa #',
        pageNumber: 'Página: ',
        createNewTask: 'Criar Nova Tarefa',
        selectChapter: 'Selecione um Capítulo',
        selectComments: 'Selecione Comentários (Opcional)',
        selectEditor: 'Selecione um Editor Responsável',
        taskInstructions: 'Instruções da Tarefa',
        createTask: 'Criar Tarefa',
        cancel: 'Cancelar',
        failedToLoadChapters: 'Falha ao carregar capítulos',
        failedToLoadEditors: 'Falha ao carregar editores',
        failedToLoadComments: 'Falha ao carregar comentários',
        taskCreatedSuccessfully: 'Tarefa criada com sucesso',
        failedToCreateTask: 'Falha ao criar tarefa. Verifique se existe uma Tarefa aberta para esse capítulo',
        selectResponsibleEditor: 'Selecione um editor responsável',
        noCommentsAvailable: 'Nenhum comentário disponível para este capítulo.',
        loadingTasks: 'Carregando tarefas...',
        assignedToMe: 'Atribuídas a Mim',
        myChapterTasks: 'Tarefas dos Meus Capítulos',
        noTasksFound: 'Nenhuma tarefa encontrada',
        preview: 'Visualizar',
        reopen: 'Reabrir',
        close: 'Fechar',
        by: 'por',
        relatedComments: 'Comentários Relacionados',
        responsible: 'Responsável',
        page: 'Página',
        of: 'de',
        total: 'tarefas no total',
        showing: "Mostrando",
        commentsLow: "comentários",
        updated: "(atualizado)",
        changeResponsible: "Alterar Responsável",
        chooseResponsible: "Escolha o novo responsável pela tarefa:",
        taskDetails: "Detalhes da Tarefa",
    },
    en: {
        assignedTasks: 'Assigned Tasks',
        back: 'Back',
        failedToFetch: 'Failed to fetch tasks: ',
        failedToUpdate: 'Failed to update task: ',
        taskMarkedAs: 'Task marked as ',
        editContent: 'Edit Content',
        markAsFinished: 'Mark as Finished',
        currentOpenTask: 'Current Open Task',
        waitingForReview: 'Waiting for Review',
        closedTasks: 'Closed Tasks',
        createdOn: 'Created on: ',
        instructions: 'Instructions: ',
        comments: 'Comments: ',
        none: 'None',
        taskNumber: 'Task #',
        pageNumber: 'Page: ',
        createNewTask: 'Create New Task',
        selectChapter: 'Select a Chapter',
        selectComments: 'Select Comments (Optional)',
        selectEditor: 'Select Responsible Editor',
        taskInstructions: 'Task Instructions',
        createTask: 'Create Task',
        cancel: 'Cancel',
        failedToLoadChapters: 'Failed to load chapters',
        failedToLoadEditors: 'Failed to load editors',
        failedToLoadComments: 'Failed to load comments',
        taskCreatedSuccessfully: 'Task created successfully',
        failedToCreateTask: 'Task creation failed. Ensure there is an open task for this chapter.',
        selectResponsibleEditor: 'Select a responsible editor',
        noCommentsAvailable: 'No comments available for this chapter.',
        loadingTasks: 'Loading tasks...',
        assignedToMe: 'Assigned to Me',
        myChapterTasks: 'My Chapter Tasks',
        noTasksFound: 'No tasks found',
        preview: 'Preview',
        reopen: 'Reopen',
        close: 'Close',
        by: 'by',
        relatedComments: 'Related Comments',
        responsible: 'Responsible',
        page: 'Page',
        of: 'of',
        total: 'total tasks',
        showing: "Showing",
        commentsLow: "comments",
        updated: "(updated)",
        changeResponsible: "Change Responsible",
        chooseResponsible: "Choose the new responsible for the task:",
        taskDetails: "Task Details",
    },
};

export default translations;